import { createFileRoute } from '@tanstack/react-router'
import { TranslatePage } from '@/features/translate/TranslatePage'

export const Route = createFileRoute('/_authenticated/translate')({
  component: TranslatePage,
})
